<template>
    <!-- 活动状态弹窗：已结束、未开始、已暂停 -->
    <div v-if="dialogVisible"
        class="activity-status">
        <div class="dialog-wrapper">
            <!-- 标题 -->
            <div class="title">{{ headerText }}</div>
            <!-- 图片 -->
            <div class="img-wrapper"
                :style="{ width: activityStatus === notStarted ? '42.3vw' : '50.1vw' }">
                <img :src="imgUrl" />
            </div>
            <!-- 文本区域 -->
            <div class="text-area"
                :style="{
          'margin-bottom': activityStatus === paused ? '3.03vw' : '15.95vw'
        }">
                <div class="activity-desc">{{ activityDesc }}</div>
                <div class="activity-during-date">{{ activityDuringDate }}</div>
            </div>
            <!-- 关闭图标 -->
            <div v-if="activityStatus === finished"
                class="close-icon"
                @click="close">
                <img src="../../../../../static/runtime/images/magic/close-icon.png" />
            </div>
        </div>
    </div>
</template>

<script>
import { ActivityStatus } from '../../../../commons/commonVariables';

export default {
  props: {
    // 活动状态
    activityStatus: {
      type: String,
      default: '',
    },
    // 活动开始时间
    activityStartDate: {
      type: String,
      default: '',
    },
    // 活动结束时间
    activityEndDate: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      notStartImgUrl: 'static/image/未开始.png',
      pausedImgUrl: 'static/image/activityPaused.png',
      isOverImgUrl: 'static/image/已结束.png',
      paused: ActivityStatus.paused,
      notStarted: ActivityStatus.notStarted,
      finished: ActivityStatus.finished,
      dialogVisible: false,
    };
  },
  computed: {
    // 展示的图片URL
    imgUrl() {
      let res = '';
      switch (this.activityStatus) {
        case ActivityStatus.notStarted:
          res = this.notStartImgUrl;
          break;
        case ActivityStatus.paused:
          res = this.pausedImgUrl;
          break;
        case ActivityStatus.finished:
          res = this.isOverImgUrl;
          break;
        default:
          res = '';
      }
      return res;
    },
    // 标题文案
    headerText() {
      let res = '';
      switch (this.activityStatus) {
        case ActivityStatus.notStarted:
          res = '活动未开始';
          break;
        case ActivityStatus.paused:
          res = '活动已暂停';
          break;
        case ActivityStatus.finished:
          res = '活动已结束';
          break;
        default:
          res = '';
      }
      return res;
    },
    // 活动说明
    activityDesc() {
      let res = '';
      switch (this.activityStatus) {
        case ActivityStatus.notStarted:
          res = '此活动未开始，请持续关注';
          break;
        case ActivityStatus.paused:
          res = '此活动已暂停，请持续关注';
          break;
        case ActivityStatus.finished:
          res = '很遗憾，此活动已结束';
          break;
        default:
          res = '';
      }
      return res;
    },
    activityDuringDate() {
      if (this.activityStatus !== ActivityStatus.paused) {
        return `活动起止时间：${this.formatDate(this.activityStartDate)}-${this.formatDate(this.activityEndDate)}`;
      } else {
        return '';
      }
    },
  },
  created() {},
  methods: {
    open() {
      this.dialogVisible = true;
    },
    close() {
      this.dialogVisible = false;
    },
    /**
     * 格式化日期为: YYYY年MM月DD日
     * @param {string} val 日期，例："2024-01-02 23:59:59
     */
    formatDate(val) {
      if (val) {
        const YMDStr = val.split(' ')[0] || '';
        const arr = YMDStr.split('-');
        return `${arr[0] || '-'}年${arr[1] || '-'}月${arr[2] || '-'}日`;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.activity-status {
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9999;
  background: rgba($color: #000000, $alpha: 0.7);
  .dialog-wrapper {
    position: absolute;
    width: 85.3vw;
    background-color: #fff;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    border-radius: 12px;
    text-align: center;
    .title {
      font-family: HONORSansBrand-DemiBold;
      font-size: 4.8vw;
      color: #000000;
      letter-spacing: 0;
      text-align: center;
      font-weight: 600;
      margin-top: 9.08vw;
      margin-bottom: 7.27vw;
      height: 5.73vw;
    }

    .img-wrapper {
      height: 37.87vw;
      margin: 0 auto;
      margin-bottom: 9.29vw;
      img {
        width: 100%;
        height: 100%;
      }
    }

    .text-area {
      min-height: 12.31vw;
      padding: 0 10px;
      .activity-desc {
        font-family: PingFangSC-Regular;
        font-size: 3.73vw;
        color: #000000;
        text-align: center;
        line-height: 6.13vw;
        font-weight: 400;
      }

      .activity-during-date {
        font-family: PingFangSC-Regular;
        font-size: 3.2vw;
        color: #000000;
        text-align: center;
        line-height: 6.13vw;
        font-weight: 400;
      }
    }

    .close-icon {
      width: 6.67vw;
      height: 6.67vw;
      position: absolute;
      bottom: -9.33vw;
      left: 50%;
      transform: translateX(-50%);
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/page/vibrantRubikCube/runtime/themaicComponent/activity-status-dialog.vue